var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"pa-0"},[_c('Landing'),_c('v-container',{staticClass:"pa-0 d-flex align-center justify-center flex-wrap",attrs:{"id":"custom-container"}},_vm._l((_vm.C_cirlces),function(circle,circleInd){return _c('CustomShape',{key:circleInd,class:[
          { 'mx-3': _vm.$vuetify.breakpoint.smAndDown && circleInd != 2 },
          { 'mx-10': !_vm.$vuetify.breakpoint.smAndDown && circleInd == 1 },
          {
            'mt-n16':
              (_vm.$vuetify.breakpoint.xsOnly && circleInd != 2) ||
              !_vm.$vuetify.breakpoint.xsOnly,
          },
          { 'mt-n8': _vm.$vuetify.breakpoint.xsOnly && circleInd === 2 },
        ],attrs:{"circle":circle,"isSquare":_vm.$vuetify.breakpoint.smAndDown,"circleInd":circleInd}})}),1),_c('SectionTwo'),_c('SectionThree'),(true)?_c('SectionFour'):_vm._e(),_c('SectionFive'),_c('SectionSex'),_c('SectionSeven'),_c('SectionEight'),_c('SectionNine')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }